import { BridgeProvider } from '@/features/crosschain-buy/domain/flow'
import { compositeStrategy } from './composite.strategy'
import { layerswapStrategy } from './layerswap.strategy'
import { rangoStrategy } from './rango.strategy'
import { symbiosisStrategy } from './symbiosis.strategy'
import type { RouteStrategy } from './types'

export function getStrategy(
  provider: BridgeProvider | undefined,
  isComposite: boolean
): RouteStrategy | null {
  if (isComposite) return compositeStrategy
  switch (provider) {
    case BridgeProvider.RANGO:
      return rangoStrategy
    case BridgeProvider.LAYERSWAP:
      return layerswapStrategy
    case BridgeProvider.SYMBIOSIS:
      return symbiosisStrategy
    case undefined:
    default:
      return null
  }
}

export type { RouteStrategy } from './types'
